import { IFileTypesMapping, ILanguageMapping } from "./interfaces";

export const FILE_TYPES = ["docx", "pptx"];
export const LANGUAGES = ["en", "de"];

export const FILE_TYPES_MAPPING = {
  docx: "WORD",
  pptx: "POWERPOINT",
} as IFileTypesMapping;

export const LANGUAGES_MAPPING = {
  en: "ENGLISH",
  de: "GERMAN",
} as ILanguageMapping;
